/* eslint-disable */

/**
 * Following dependency resolution issues and the time sensitivity requried,
 * this is a dump of the @segment/utm-params and component/query-string libs.
 */

const decode = (str) => {
  try {
    return decodeURIComponent(str.replace(/\+/g, ' '));
  } catch (e) {
    return str;
  }
};

const parse = (str) => {
  if (typeof str !== 'string') return {};

  str = str.trim();
  if (str === '') return {};
  if (str.charAt(0) === '?') str = str.slice(1);

  const obj = {};
  const pairs = str.split('&');
  for (let i = 0; i < pairs.length; i += 1) {
    const parts = pairs[i].split('=');
    const key = decode(parts[0]);
    let m;

    if ((m = /(\w+)\[(\d+)\]/.exec(key))) {
      obj[m[1]] = obj[m[1]] || [];
      obj[m[1]][m[2]] = decode(parts[1]);
      continue;
    }

    obj[parts[0]] = parts[1] == null ? '' : decode(parts[1]);
  }

  return obj;
};

const utm = (query) => {
  // Remove leading ? if present
  if (query.charAt(0) === '?') {
    query = query.substring(1);
  }

  query = query.replace(/\?/g, '&');

  let param;
  const params = parse(query);
  const results = {};

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      if (key.substr(0, 4) === 'utm_') {
        param = key.substr(4);
        if (param === 'campaign') param = 'name';
        results[param] = params[key];
      }
    }
  }

  return results;
};

export default utm;
